import { StatsCards } from './StatsCards'
import { OnboardingChecklist } from './OnboardingChecklist'
import { QuickLinks } from './QuickLinks'
import { useAuth } from '@/hooks/useAuth'
import { AccountHeader } from '@theseus/shared-ui/account'

export function Overview() {
  const { getUserMetadata } = useAuth()
  const metadata = getUserMetadata()

  return (
    <div className="space-y-6">
      {/* Header */}
      <AccountHeader firstName={metadata.full_name?.split(' ')[0]} />

      {/* Stats Cards */}
      <StatsCards />

      {/* Two Column Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Onboarding */}
        <OnboardingChecklist />

        {/* Quick Links */}
        <QuickLinks />
      </div>
    </div>
  )
}
